module.exports = "<div class=\"coming-soon\">\n\t<h1>Coming soon feature</h1>\n</div>"